import { z } from "zod";

// Метаданные поля
export const zFieldMeta = z.object({
  field: z.string(),
  fieldType: z.enum(["SYSTEM", "SPEC"]),
  specName: z.string().optional(),
});
export type ZFieldMeta = z.infer<typeof zFieldMeta>;

// Тип значения фильтра
export const zFilterValueType = z.enum([
  "TEXT",
  "NUMBER",
  "DATETIME",
  "BOOLEAN",
]);
export type ZFilterValueType = z.infer<typeof zFilterValueType>;

// Значение фильтра
export const zFilterValue = z.union([
  z.string(),
  z.number(),
  z.boolean(),
  z.null(),
]);
export type ZFilterValue = z.infer<typeof zFilterValue>;

// Критерий фильтрации
export const zFilterCriterion = z.object({
  fieldMeta: zFieldMeta,
  type: zFilterValueType,
  operator: z.string(),
  value: zFilterValue.optional(),
});
export type ZFilterCriterion = z.infer<typeof zFilterCriterion>;

// Группа фильтров (рекурсивная)
export type ZFilterGroup = {
  op: "AND" | "OR";
  items: ZFilterItem[];
};

export type ZFilterItem = ZFilterCriterion | ZFilterGroup;

export const zFilterItem: z.ZodType<ZFilterItem> = z.lazy(() =>
  z.union([zFilterGroup, zFilterCriterion]),
);

export const zFilterGroup: z.ZodType<ZFilterGroup> = z.lazy(() =>
  z.object({
    op: z.enum(["AND", "OR"]),
    items: z.array(zFilterItem),
  }),
);

// Запрос фильтрации
export const zFilterRequest = z.object({
  filter: zFilterGroup,
});
export type ZFilterRequest = z.infer<typeof zFilterRequest>;

export const zFilterTemplate = zFilterRequest.extend({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  version: z.string(),
});
export type ZFilterTemplate = z.infer<typeof zFilterTemplate>;
export type ZFilterTemplateCreate = Omit<ZFilterTemplate, "id">;

// Type guards
export const isFilterGroup = (item: ZFilterItem): item is ZFilterGroup =>
  "op" in item && "items" in item;

export const isFilterCriterion = (
  item: ZFilterItem,
): item is ZFilterCriterion =>
  "fieldMeta" in item && "type" in item && "operator" in item;
